var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E9E9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_close_svg__clip0_24_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 10L12 14.667 7.333 10",
    stroke: "#122549",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_close_svg__clip0_24_1312"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgArrowClose;